import React from 'react'
import Header from '../Layout/Header'
import Footer from '../Layout/Footer'
import { Link } from 'react-router-dom'
import Aboutpro from '../Home/Aboutpro'
import PropertySection from '../Home/PropertySection'
import LeadersSection from '../Home/LeadersSection'
import Testtomonial from '../Home/Testtomonial'
import NewsSection from '../Home/NewsSection'
import ContactSection from '../Home/ContactSection'

function NewAbout() {
  return (
    <div>
        <Header />
         {/* <!-- Breadcrumb Section Start --> */}
        <div class="gt-breadcrumb-wrapper bg-cover"  style={{
        backgroundImage: "url('/assets/img/breadcrumb-bg.jpg')"
        
      }}>
            <div class="container">
                <div class="gt-page-heading">
                    <div class="gt-breadcrumb-sub-title">
                        <h1 class="wow fadeInUp" data-wow-delay=".3s">About Us</h1>
                    </div>
                    <ul class="gt-breadcrumb-items wow fadeInUp" data-wow-delay=".5s">
                        <li>
                          <Link to="/">Home</Link>
                        </li>
                        <li>
                            <i class="fa-solid fa-chevron-right"></i>
                        </li>
                        <li>
                          About Us
                        </li>
                    </ul>
                </div>
            </div>
        </div>

   
        <section class="about-section fix section-bg section-padding">
            {/* <div class="right-shape">
                <img src="assets/img/home-1/about/right-shape.png" alt="img"/>
            </div>
            <div class="container">
                <div class="about-wrapper">
                    <div class="row g-4 align-items-center">
                        <div class="col-lg-6 wow fadeInUp" data-wow-delay=".3s">
                            <div class="about-image">
                                <img src="assets/img/home-1/about/about-01.png" alt="img"/>
                                <div class="about-image-2">
                                    <img src="assets/img/home-1/about/about-02.png" alt="img"/>
                                </div>
                                <div class="counter-box">
                                    <h2><span class="count">697</span>k+</h2>
                                    <p>LISTED PROPERTIES</p>
                                </div>
                                <span class="bar-shape"></span>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="about-content">
                                <div class="section-title mb-0">
                                    <h5 class="wow fadeInUp"><i class="flaticon-home"></i> WHO WE ARE</h5>
                                    <h2 class="wow fadeInUp" data-wow-delay=".3s">
                                        Where Finding a House Feels Like Home
                                    </h2>
                                </div>
                                <p class="about-text wow fadeInUp" data-wow-delay=".5s">
                                    At our core, we believe finding a home should feel comforting, not complicated. That’s why we offer trusted listings, expert support, and a seamless experience tailored to your needs and dreams.
                                </p>
                                <ul class="wow fadeInUp" data-wow-delay=".7s">
                                    <li>
                                        <i class="flaticon-right-arrow"></i> Pontificate the client proactively
                                    </li>
                                    <li>
                                        <i class="flaticon-right-arrow"></i> Does the selected item have a waiting list?
                                    </li>
                                    <li>
                                        <i class="flaticon-right-arrow"></i> Instant 24-hour Emergency
                                    </li>
                                </ul>
                                <div class="about-btn wow fadeInUp" data-wow-delay=".3s">
                                    <a href="about.html" class="theme-btn">
                                        ABOUT US MORE <i class="flaticon-home"></i> 
                                    </a>
                                    <div class="call-info">
                                        <div class="icon">
                                            <i class="fa-solid fa-phone-xmark"></i>
                                        </div>
                                        <div class="content">
                                            <span>Call Us 24/7</span>
                                            <h4><a href="tel:+20866660112">+208-6666-0112</a></h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            
            <Aboutpro />
        </section>
        
    <LeadersSection />
        {/* <!-- House Offer Section Start --> */}
        <section class="house-offer-section fix section-padding">
            {/* <div class="container">
                <div class="section-title text-center">
                    <h5 class="wow fadeInUp"><i class="flaticon-home"></i> HOUSE HIGHLIGHTS <i class="flaticon-home"></i></h5>
                    <h2 class="wow fadeInUp" data-wow-delay=".3s">What This House Offers</h2>
                </div>
                <div class="row row-cols-xxl-6 row-cols-xl-5 row-cols-lg-3 row-cols-md-3 row-cols-sm-2 row-cols-1">
                    <div class="col wow fadeInUp">
                        <div class="house-offer-box section-bg-3 style-2">
                            <div class="icon-1">
                                <i class="flaticon-rooftop"></i>
                            </div>
                            <div class="content">
                                <h4>Rooftop Garden</h4>
                            </div>
                        </div>
                    </div>
                    <div class="col wow fadeInUp" data-wow-delay=".2s">
                        <div class="house-offer-box section-bg-3 style-2">
                            <div class="icon-1">
                                <i class="flaticon-parking"></i>
                            </div>
                            <div class="content">
                                <h4>Car Parking</h4>
                            </div>
                        </div>
                    </div>
                    <div class="col wow fadeInUp" data-wow-delay=".4s">
                        <div class="house-offer-box section-bg-3 style-2">
                            <div class="icon-1">
                                <i class="flaticon-dumbbell"></i>
                            </div>
                            <div class="content">
                                <h4>Fitness Center</h4>
                            </div>
                        </div>
                    </div>
                    <div class="col wow fadeInUp" data-wow-delay=".6s">
                        <div class="house-offer-box section-bg-3 style-2">
                            <div class="icon-1">
                                <i class="flaticon-pet-care"></i>
                            </div>
                            <div class="content">
                                <h4>Pet Friendly</h4>
                            </div>
                        </div>
                    </div>
                    <div class="col wow fadeInUp" data-wow-delay=".8s">
                        <div class="house-offer-box section-bg-3 style-2">
                            <div class="icon-1">
                                <i class="flaticon-facility"></i>
                            </div>
                            <div class="content">
                                <h4>Indoor Pool</h4>
                            </div>
                        </div>
                    </div>
                    <div class="col wow fadeInUp" data-wow-delay=".9s">
                        <div class="house-offer-box section-bg-3 style-2">
                            <div class="icon-1">
                                <i class="flaticon-playground"></i>
                            </div>
                            <div class="content">
                                <h4>Playground</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
             <PropertySection/>
        </section>

{/*    
        <section class="propertie-section-3 fix section-padding bg-cover"  style={{
        backgroundImage: "url('/assets/img/propertie-bg.jpg')"
       
      }}>
            <div class="container">
                <div class="propertie-wrapper-3">
                    <div class="row g-4">
                        <div class="col-xl-6 col-lg-6">
                            <div class="content">
                                <div class="section-title mb-0">
                                    <h5 class="wow fadeInUp"><i class="flaticon-home"></i>D I S C O V E R T H E B E S T <i class="flaticon-home"></i></h5>
                                    <h2 class="wow fadeInUp" data-wow-delay=".3s">Property Floor Plan</h2>
                                </div>
                                <ul class="nav">
                                    <li class="nav-item wow fadeInUp" data-wow-delay=".2s">
                                        <a href="#View" data-bs-toggle="tab" class="nav-link">
                                           360° View
                                        </a>
                                    </li>
                                    <li class="nav-item wow fadeInUp" data-wow-delay=".4s">
                                        <a href="#Photo" data-bs-toggle="tab" class="nav-link active">
                                            Property Photo
                                        </a>
                                    </li>
                                    <li class="nav-item wow fadeInUp" data-wow-delay=".6s">
                                        <a href="#Videos" data-bs-toggle="tab" class="nav-link">
                                           Property Videos
                                        </a>
                                    </li>
                                </ul>
                                <div class="tab-content">
                                    <div id="View" class="tab-pane fade">
                                        <ul class="list-items">
                                            <li>
                                                <i class="flaticon-right-arrow"></i> Total Area 2500 sq.ft
                                            </li>
                                                <li>
                                                <i class="flaticon-right-arrow"></i> Floor No. 02
                                            </li>
                                                <li>
                                                <i class="flaticon-right-arrow"></i> Current Status Available
                                            </li>
                                                <li>
                                                <i class="flaticon-right-arrow"></i> No. of Rooms 03
                                            </li>
                                                <li>
                                                <i class="flaticon-right-arrow"></i> Home Gyme Available
                                            </li>
                                                <li>
                                                <i class="flaticon-right-arrow"></i> Parking Available Yes
                                            </li>
                                                <li>
                                                <i class="flaticon-right-arrow"></i> Smoking/Pets Allowed
                                            </li>
                                                <li>
                                                <i class="flaticon-right-arrow"></i> Living Room 55 sq. ft
                                            </li>
                                        </ul>
                                    </div>
                                    <div id="Photo" class="tab-pane fade show active">
                                        <ul class="list-items wow fadeInUp" data-wow-delay=".3s">
                                            <li>
                                                <i class="flaticon-right-arrow"></i> Total Area 2500 sq.ft
                                            </li>
                                                <li>
                                                <i class="flaticon-right-arrow"></i> Floor No. 02
                                            </li>
                                                <li>
                                                <i class="flaticon-right-arrow"></i> Current Status Available
                                            </li>
                                                <li>
                                                <i class="flaticon-right-arrow"></i> No. of Rooms 03
                                            </li>
                                                <li>
                                                <i class="flaticon-right-arrow"></i> Home Gyme Available
                                            </li>
                                                <li>
                                                <i class="flaticon-right-arrow"></i> Parking Available Yes
                                            </li>
                                                <li>
                                                <i class="flaticon-right-arrow"></i> Smoking/Pets Allowed
                                            </li>
                                                <li>
                                                <i class="flaticon-right-arrow"></i> Living Room 55 sq. ft
                                            </li>
                                        </ul>
                                    </div>
                                    <div id="Videos" class="tab-pane fade">
                                        <ul class="list-items">
                                            <li>
                                                <i class="flaticon-right-arrow"></i> Total Area 2500 sq.ft
                                            </li>
                                                <li>
                                                <i class="flaticon-right-arrow"></i> Floor No. 02
                                            </li>
                                                <li>
                                                <i class="flaticon-right-arrow"></i> Current Status Available
                                            </li>
                                                <li>
                                                <i class="flaticon-right-arrow"></i> No. of Rooms 03
                                            </li>
                                                <li>
                                                <i class="flaticon-right-arrow"></i> Home Gyme Available
                                            </li>
                                                <li>
                                                <i class="flaticon-right-arrow"></i> Parking Available Yes
                                            </li>
                                                <li>
                                                <i class="flaticon-right-arrow"></i> Smoking/Pets Allowed
                                            </li>
                                                <li>
                                                <i class="flaticon-right-arrow"></i> Living Room 55 sq. ft
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6">
                            <div class="propertie-image">
                                <img src="assets/img/propertie-image.jpg" alt="img"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section> */}

      
     <Testtomonial/>
     <NewsSection />
     <ContactSection/>
        <Footer/>
    </div>
  )
}

export default NewAbout
